import { Trans, useTranslation } from 'react-i18next';

/**
 * The attribution Google requires from any site that hides the reCAPTCHA badge. Varza hides it — a floating
 * overlay pinned to a corner does not survive a bilingual, right-to-left layout — so the notice appears
 * instead, on the forms the token is actually minted for.
 */
export function RecaptchaNotice() {
  const { t } = useTranslation();

  return (
    <p className="recaptcha-notice" dir="auto">
      <Trans
        t={t}
        i18nKey="security.recaptchaNotice"
        components={{
          privacy: (
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">
              privacy
            </a>
          ),
          terms: (
            <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer noopener">
              terms
            </a>
          ),
        }}
      />
    </p>
  );
}
